import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { ToastrService } from 'ngx-toastr';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-stripe-pay',
  templateUrl: './stripe-pay.component.html',
  styleUrls: ['./stripe-pay.component.scss']
})
export class StripePayComponent implements OnInit {

  cculture = '';
  regexPattern = '';
  Id = '';
  PhoneNumber = '';

  stripe: Stripe | null = null;

  // Copy this from the dashboard: https://dashboard.stripe.com/test/apikeys
  PUBLISHABLE_KEY: string = "pk_live_7CWTGtlgccfOgD6B1BvBDFv6";

  constructor(
    private readonly coreService: CoreService,
    private readonly route: ActivatedRoute,
    private translate: TranslateService,
    private toast: ToastrService
  ) {
    this.route.queryParams.subscribe(params => {
      this.Id = params.id;
    });
  }

  async ngOnInit(): Promise<void> {
    this.stripe = await loadStripe(this.PUBLISHABLE_KEY);
  }

  checkout(): void {
    const body = { id: this.Id };
    this.coreService.stripePay(body).then((response: any) => {
      if (this.stripe) {
        this.stripe.redirectToCheckout({ sessionId: response.sessionId });
      }
    }).catch((errorResponse: any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, '');
    });
  }
}
